import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Loader, Icon} from 'semantic-ui-react';

class Sustitute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
    this.onGoToSustituteClick = this.onGoToSustituteClick.bind(this);
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  onGoToSustituteClick(code) {
    this.props.push(`/partes/consultas/ver/${code}`);
  }

  renderItems() {
    const {replacement} = this.props;
    if (!Object.keys(replacement).length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={2}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Table.Row>
        <Table.Cell textAlign='center'>
          <a
            className='link'
            onClick={() => this.onGoToSustituteClick(replacement.code)}
          >
            {replacement.code}
          </a>
        </Table.Cell>
        <Table.Cell textAlign='right'>
          {replacement.stockToyotaEcuador}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  render() {
    const {activeIndex} = this.state;
    const {replacement} = this.props;

    return (
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan={1} textAlign='left'>
                  Sustituto
                  <span className='quantity-container'>
                    {replacement.stockToyotaEcuador || 0}
                  </span>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={1} textAlign='right'>
                  <Icon name='dropdown' />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 0}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderData()}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  const data = state.parts.partData;
  const replacement = data.replacement || {};
  return {
    'loading': state.parts.loading,
    replacement,
  };
};

export default connect(mapStateToProps, {})(Sustitute);
